module.exports = __webpack_public_path__ + "img/26-ram.c5df9580.jpg";